;(() => {
  if (window.__MediaModalInited) return
  window.__MediaModalInited = true

  const q = (sel, root) => (root || document).querySelector(sel)
  const qAll = (sel, root) => Array.from((root || document).querySelectorAll(sel))

  const injectStylesOnce = () => {
    if (q("#media-modal-styles")) return
    const style = document.createElement("style")
    style.id = "media-modal-styles"
    style.textContent = `
.media-modal-backdrop{position:fixed;inset:0;background:rgba(0,0,0,.85);display:flex;align-items:center;justify-content:center;z-index:9999;padding:20px}
.media-modal-dialog{position:relative;max-width:1200px;width:100%;aspect-ratio:16/9;border-radius:12px;overflow:hidden;background:#000;box-shadow:0 20px 60px rgba(0,0,0,.6)}
.media-modal-content{width:100%;height:100%;display:flex;align-items:center;justify-content:center}
.media-modal-content iframe,.media-modal-content video{display:block;width:100%;height:100%;border:0}
.media-modal-content img{display:block;max-width:100%;max-height:90vh;object-fit:contain}
.media-modal-close{position:absolute;top:16px;right:16px;background:rgba(255,255,255,.9);color:#111;border:0;width:40px;height:40px;border-radius:50%;cursor:pointer;display:flex;align-items:center;justify-content:center;font-size:24px;font-weight:700;z-index:10;transition:transform .2s}
.media-modal-close:hover{transform:scale(1.1);background:#fff}
.media-modal-close:focus{outline:2px solid #fff;outline-offset:2px}
@media (max-width:768px){
  .media-modal-dialog{aspect-ratio:auto;max-height:80vh}
}
`
    document.head.appendChild(style)
  }

  const parseYoutubeId = url => {
    if (!url) return null
    try {
      const u = new URL(url, window.location.href)
      if (u.hostname.includes("youtu.be")) return u.pathname.slice(1)
      if (u.hostname.includes("youtube.com")) {
        if (u.searchParams.get("v")) return u.searchParams.get("v")
        const p = u.pathname.split("/").filter(Boolean)
        const i = p.indexOf("embed")
        if (i >= 0 && p[i + 1]) return p[i + 1]
      }
    } catch (_e) {}
    return null
  }

  const parseVimeoId = url => {
    if (!url) return null
    try {
      const u = new URL(url, window.location.href)
      if (!u.hostname.includes("vimeo.com")) return null
      const parts = u.pathname.split("/").filter(Boolean)
      const last = parts.pop()
      return /^\d+$/.test(last || "") ? last : null
    } catch (_e) {}
    return null
  }

  const buildYoutubeEmbed = id => `https://www.youtube.com/embed/${id}?autoplay=1&rel=0`
  const buildVimeoEmbed = id => `https://player.vimeo.com/video/${id}?autoplay=1`

  const stopIframe = iframe => {
    if (!iframe) return
    try {
      const src = iframe.getAttribute("src")
      iframe.setAttribute("src", src || "")
    } catch (_e) {}
  }

  const createCloseButton = () => {
    const btn = document.createElement("button")
    btn.type = "button"
    btn.className = "media-modal-close"
    btn.setAttribute("aria-label", "Close media")
    btn.innerHTML = "&times;"
    return btn
  }

  const openModal = ({ type, src, alt }) => {
    injectStylesOnce()
    const backdrop = document.createElement("div")
    backdrop.className = "media-modal-backdrop"
    backdrop.setAttribute("role", "dialog")
    backdrop.setAttribute("aria-modal", "true")
    backdrop.setAttribute("aria-label", "Media viewer")
    backdrop.tabIndex = -1

    const dialog = document.createElement("div")
    dialog.className = "media-modal-dialog"
    const content = document.createElement("div")
    content.className = "media-modal-content"
    const closeBtn = createCloseButton()

    let node = null
    if (type === "image") {
      node = document.createElement("img")
      node.src = src
      node.alt = alt || ""
      node.loading = "eager"
    } else if (type === "youtube") {
      const id = parseYoutubeId(src)
      const embed = id ? buildYoutubeEmbed(id) : null
      node = document.createElement("iframe")
      node.src = embed || src
      node.setAttribute("allow", "autoplay; encrypted-media; picture-in-picture")
      node.setAttribute("allowfullscreen", "true")
      node.setAttribute("title", alt || "YouTube video")
    } else if (type === "vimeo") {
      const id = parseVimeoId(src)
      const embed = id ? buildVimeoEmbed(id) : null
      node = document.createElement("iframe")
      node.src = embed || src
      node.setAttribute("allow", "autoplay; encrypted-media; picture-in-picture")
      node.setAttribute("allowfullscreen", "true")
      node.setAttribute("title", alt || "Vimeo video")
    } else {
      node = document.createElement("video")
      node.src = src
      node.autoplay = true
      node.controls = true
      node.playsInline = true
    }

    content.appendChild(node)
    dialog.appendChild(content)
    dialog.appendChild(closeBtn)
    backdrop.appendChild(dialog)
    document.body.appendChild(backdrop)

    const active = document.activeElement
    closeBtn.focus()

    const cleanup = () => {
      if (!backdrop.parentElement) return
      const iframe = q("iframe", content)
      const video = q("video", content)
      if (video) {
        try {
          video.pause()
          video.removeAttribute("src")
          video.load()
        } catch (_e) {}
      }
      if (iframe) stopIframe(iframe)
      backdrop.remove()
      if (active && typeof active.focus === "function") active.focus()
      document.removeEventListener("keydown", onEsc)
    }

    const onEsc = e => {
      if (e.key === "Escape") cleanup()
    }
    document.addEventListener("keydown", onEsc)

    closeBtn.addEventListener("click", cleanup)
    backdrop.addEventListener("click", e => {
      if (e.target === backdrop) cleanup()
    })
  }

  const getTriggerPayload = el => {
    const dataType = el.getAttribute("data-type") || ""
    const srcAttr = el.getAttribute("data-src") || el.getAttribute("href") || ""
    const alt = el.getAttribute("data-alt") || el.getAttribute("aria-label") || el.getAttribute("title") || ""

    let type = dataType.toLowerCase()
    if (!type) {
      const yt = parseYoutubeId(srcAttr)
      const vm = parseVimeoId(srcAttr)
      if (yt) type = "youtube"
      else if (vm) type = "vimeo"
      else if (/\.(mp4|webm|ogg)(\?|#|$)/i.test(srcAttr)) type = "video"
      else type = "image"
    }
    return { type, src: srcAttr, alt }
  }

  const handleClick = e => {
    const trigger = e.target.closest("[data-media-modal]")
    if (!trigger) return
    e.preventDefault()
    const payload = getTriggerPayload(trigger)
    if (!payload.src) return
    openModal(payload)
  }

  const handleKeydown = e => {
    const trigger = e.target.closest("[data-media-modal]")
    if (!trigger) return
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault()
      const payload = getTriggerPayload(trigger)
      if (!payload.src) return
      openModal(payload)
    }
  }

  const boot = root => {
    injectStylesOnce()
    qAll("[data-media-modal]", root).forEach(el => {
      if (el.__mediaBound) return
      el.__mediaBound = true
      el.setAttribute("role", el.tagName === "BUTTON" || el.tagName === "A" ? el.getAttribute("role") || "" : "button")
      el.tabIndex = el.tabIndex >= 0 ? el.tabIndex : 0
    })
  }

  document.addEventListener("click", handleClick)
  document.addEventListener("keydown", handleKeydown)

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => boot())
  } else {
    boot()
  }
  document.addEventListener("shopify:section:load", e => boot(e.target))
})()


